import { Link } from 'react-router-dom';

export interface Breadcrumb {
  label: string;
  link?: string;
}

export const BreadCrumb = ({ breadcrumbs }: { breadcrumbs: Breadcrumb[] }) => {
  return (
    <nav aria-label="breadcrumb" className="hidden md:block">
      <div className="breadcrumb flex flex-row">
        {breadcrumbs.map((breadcrumb, index) => (
          <div
            className={`flex p-2 flex-row rounded-lg ${index === breadcrumbs.length - 1 ? 'bg-quipli-yellow-100' : ''}`}
            key={index}
          >
            <div key={index} className="breadcrumb-item">
              {breadcrumb.link ? (
                <Link className="underline font-bold text-blue-500 visited:text-blue-500" to={breadcrumb.link}>
                  {breadcrumb.label}
                </Link>
              ) : (
                <span className={`font-bold ${index !== breadcrumbs.length - 1 ? 'text-grey-500' : 'text-black'}`}>
                  {breadcrumb.label}
                </span>
              )}
            </div>
            {index < breadcrumbs.length - 1 && <span className="mx-2 text-gray-500 ml-[1.5rem]">{'>'}</span>}
          </div>
        ))}
      </div>
    </nav>
  );
};
